import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
// import { AxiosResponse } from "axios";

export default {
    async list(): Promise<types.ResMainSector> {
        const res = {} as types.ResMainSector;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/main/sector/list", null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async modify(param: types.ReqMainSectorForOrder): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/main/sector/modify", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
};
